module.exports = __webpack_public_path__ + "cf830f6af0aa0f2a584cf100288fb090.png";